import type { Event } from 'models';
import { useUser } from 'features/auth';
import { SharedEventEnterFormCard, type SharedEventEnterFormValues } from '../../../../components';
import { useOnRequestEnterEvent } from '../../../../hooks';

type P = {
  event: Event;
  invitationToken: string;
};

const SharedEventForm = ({ event, invitationToken }: P) => {
  const user = useUser({ requiredAuth: false });
  const { isJoining, onRequestEnterEvent } = useOnRequestEnterEvent();

  const onFinish = (values: SharedEventEnterFormValues) => {
    onRequestEnterEvent({
      baseUrl: window.location.origin,
      email: values.email,
      feedback: false,
      firstName: values.firstName,
      id: event.id,
      invitationToken,
      lastName: values.lastName,
      type: 'public',
    });
  };

  return (
    <SharedEventEnterFormCard
      initialValues={{
        email: user?.nodeUserData.email,
        firstName: user?.nodeUserData.firstName,
        lastName: user?.nodeUserData.lastName,
      }}
      loading={isJoining}
      onFinish={onFinish}
    />
  );
};

export default SharedEventForm;
